import { TicketStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useMemo } from "react";

import { UseEventTicketAggregationProgress } from "./types";

export const useEventTicketAggregationProgress: UseEventTicketAggregationProgress =
  (ticketsAggregation) =>
    useMemo(() => {
      const { tickets } = ticketsAggregation || {};

      const initialStatusValues = Object.values(TicketStatus).reduce(
        (reduced, status) => ({ ...reduced, [status]: 0 }),
        {} as Record<TicketStatus, number>
      );

      const quantities = {
        ...initialStatusValues,
        ...tickets?.reduce(
          (reduced, { status, count }) => ({
            ...reduced,
            [status]: count,
          }),
          {}
        ),
      };

      const total =
        quantities[TicketStatus.NEW] + quantities[TicketStatus.SCANNED];

      const percentages = Object.entries(quantities).reduce(
        (reduced, [status, quantity]) => ({
          ...reduced,
          [status]: total ? (quantity / total) * 100 : 0,
        }),
        {} as Record<TicketStatus, number>
      );

      return {
        total,
        quantities,
        percentages,
      };
    }, [ticketsAggregation]);
